import $http from '@/config/request';

//学校详情信息
export const getSchoolDetailApi = (params) => {
  return $http.post('/shuangshi/school/schoolDetail', params);
};

//学校课程列表
export const getSchoolCourseListApi = (params) => {
  return $http.post('/shuangshi/school/schoolCourseList', params);
};

//学校教师列表
export const getSchoolTeacherListApi = (params) => {
  return $http.post('/shuangshi/school/schoolTeacherList', params);
};

//学校掠影列表
export const getSchoolSketchListApi = (params) => {
  return $http.post('/shuangshi/school/schoolSketchList', params);
};